<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { clearRegistrationIntent } from "@/views/V2/olimpiadas/registrationFlow";

export default {
  name: "AuthLayout",
  beforeRouteLeave(to, from, next) {
    const leavingAuth = !to.path.startsWith("/v2/auth");
    if (leavingAuth && !this.$store.state.auth.isAuthenticated) {
      clearRegistrationIntent();
    }
    next();
  },
};
</script>
